import {REGIONEAEREOARRIVO} from './regioneAereoArrivoTypes'

export const changeRegioneAereoArrivo = regioneAereoArrivo => {
    return {
        type: REGIONEAEREOARRIVO,
        load: regioneAereoArrivo
    }
}

export const selectNewRegioneAereoArrivo = (regioneAereoArrivo) => {

    return (dispatch) => {
        dispatch(changeRegioneAereoArrivo(regioneAereoArrivo))
    }

}